module.exports = __webpack_public_path__ + "20221216:03503e97ddf972ec7716/img/DesktopModalSidePanel.3a5b5e4.png";